// Single source of truth for destination availability.
// Only ACTIVE destinations may appear publicly. Inactive ones stay wired for future activation.
export const DESTINATIONS = {
  Spain: { label: "Spain", active: true },
  Portugal: { label: "Portugal", active: false },
  Italy: { label: "Italy", active: false },
};

export const ALL_DESTINATIONS = Object.keys(DESTINATIONS);
export const ACTIVE_DESTINATIONS = ALL_DESTINATIONS.filter((k) => DESTINATIONS[k].active);
export const INACTIVE_DESTINATIONS = ALL_DESTINATIONS.filter((k) => !DESTINATIONS[k].active);
export const PRIMARY_DESTINATION = ACTIVE_DESTINATIONS[0];

export const isActiveDestination = (name) => !!DESTINATIONS[name]?.active;
